<template>
  <div class="cards-wrapper">
    <v-container fluid>
      <v-row class="d-flex flex-wrap">
        <v-col
          v-for="item in items"
          :key="item"
          cols="12"
          sm="9"
          :md="md"
          :lg="lg"
          :xl="xlg"
          class="d-flex card-col"
        >
          <v-card class="mx-auto flex-grow-1 d-flex flex-column w-100 pa-2" :style="CardStyle">
              <template v-slot:title>
                <div class="d-flex justify-space-between align-start">
                  <div v-show="!isHome">
                    <v-sheet class="text-left" style="text-wrap: wrap">
                      <v-sheet
                      :style="TitleStyle"
                      class="data-type-name ma-0 pa-0"
                      >
                        <v-sheet>
                          <strong>{{ item.name }}</strong>
                        </v-sheet>
                      </v-sheet>
                    </v-sheet>
                    <v-sheet>
                      <div
                        style="display: flex"
                        v-if="
                          item.updated_at != null ||
                          item.active != null ||
                          this.$attrs.onAction
                        "
                      >
                      <span
                        v-if="item.active === 0"
                        style="
                          font-family: Roboto;
                          font-size: 14px;
                          font-style: normal;
                          font-weight: 700;
                          line-height: 20px;
                          letter-spacing: 0.25px;
                          color: #A80710;
                        "
                      >
                        Desativado
                      </span>
                      <span
                        v-if="item.active === 1"
                        style="
                          color: #007B38;
                          font-family: Roboto;
                          font-size: 14px;
                          font-style: normal;
                          font-weight: 700;
                          line-height: 20px;
                          letter-spacing: 0.25px;
                        "
                      >
                        Ativado
                      </span>
                      </div>
                    </v-sheet>
                  </div>

                  <div v-show="isHome">
                    <div class="d-flex align-center" style="gap: 12px">
                       <i v-html="item.icon" class="mb-n2"></i>
                       <div
                        :style="TitleStyle"
                      >
                        <strong>{{ item.name }}</strong> | Rubeus
                       </div>
                    </div>
                    <div class="mt-2">
                      <div
                        style="display: flex"
                        v-if="
                          item.updated_at != null ||
                          item.active != null ||
                          this.$attrs.onAction
                        "
                      >
                      <span
                        v-if="item.active === 0"
                        style="
                          font-family: Roboto;
                          font-size: 14px;
                          font-style: normal;
                          font-weight: 700;
                          line-height: 20px;
                          letter-spacing: 0.25px;
                          color: #A80710;
                        "
                      >
                        Desativado
                      </span>
                      <span
                        v-if="item.active === 1"
                        style="
                          color: #007B38;
                          font-family: Roboto;
                          font-size: 14px;
                          font-style: normal;
                          font-weight: 700;
                          line-height: 20px;
                          letter-spacing: 0.25px;
                        "
                      >
                        Ativado
                      </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <v-menu
                      v-if="actionType === 'menu'"
                      location="bottom end"
                      transition="fade-transition"
                      :close-on-content-click="true"
                      offset="8"
                    >
                      <template #activator="{ props }">
                        <span v-bind="props" class="menu-dot-activator">
                          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M12.3334 20C11.7834 20 11.3125 19.8042 10.9209 19.4125C10.5292 19.0208 10.3334 18.55 10.3334 18C10.3334 17.45 10.5292 16.9792 10.9209 16.5875C11.3125 16.1958 11.7834 16 12.3334 16C12.8834 16 13.3542 16.1958 13.7459 16.5875C14.1375 16.9792 14.3334 17.45 14.3334 18C14.3334 18.55 14.1375 19.0208 13.7459 19.4125C13.3542 19.8042 12.8834 20 12.3334 20ZM12.3334 14C11.7834 14 11.3125 13.8042 10.9209 13.4125C10.5292 13.0208 10.3334 12.55 10.3334 12C10.3334 11.45 10.5292 10.9792 10.9209 10.5875C11.3125 10.1958 11.7834 10 12.3334 10C12.8834 10 13.3542 10.1958 13.7459 10.5875C14.1375 10.9792 14.3334 11.45 14.3334 12C14.3334 12.55 14.1375 13.0208 13.7459 13.4125C13.3542 13.8042 12.8834 14 12.3334 14ZM12.3334 8C11.7834 8 11.3125 7.80417 10.9209 7.4125C10.5292 7.02083 10.3334 6.55 10.3334 6C10.3334 5.45 10.5292 4.97917 10.9209 4.5875C11.3125 4.19583 11.7834 4 12.3334 4C12.8834 4 13.3542 4.19583 13.7459 4.5875C14.1375 4.97917 14.3334 5.45 14.3334 6C14.3334 6.55 14.1375 7.02083 13.7459 7.4125C13.3542 7.80417 12.8834 8 12.3334 8Z" fill="#505353"/>
                          </svg>
                        </span>
                      </template>

                      <v-card elevation="3" 
                        style="
                          background-color: #F8FAF9;
                          padding: 8px 0;
                        "
                        rounded="lg"
                        min-width="180"
                      >
                        <v-list
                          style="
                            background-color: #F8FAF9;
                          "
                        >
                          <v-list-item
                            v-if="showAccessAction"
                            prepend-icon="mdi-open-in-new"
                            title="Acessar"
                            @click="onAccess(item)"
                          />
                          <v-list-item
                            v-if="showToggleAction"
                            :prepend-icon="item.active === 1 ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline'"
                            :title="item.active === 1 ? 'Desativar' : 'Ativar'"
                            @click="onToggle(item)"
                          />
                        </v-list>
                      </v-card>
                    </v-menu>

                    <v-btn
                      v-else-if="actionType === 'redirect'"
                      icon
                      variant="text"
                      class="menu-dot-activator"
                      @click="onRedirect(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                  </div>


                </div>
              </template>
              <v-card-text
                :style="DescStyle"
                class="data-type-desc text-left flex-grow-1"
              >
                {{ item.desc }}
              </v-card-text>
              

              
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style>
.selection-part {
  position: absolute;
  bottom: 0;
  width: calc(100% - 32px);
}
.cards-wrapper {
  margin-right: 22px;
}
.card-divider {
  position: absolute;
  height: 1px;
  bottom: 52px;
  width: 100%;
  background-color: #d4d4d4;
}
.menu-dot-activator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px; height: 28px;
  border-radius: 50%;
  cursor: pointer;
}
.menu-dot-activator:hover { background: rgba(0,0,0,0.06); }

.card-col {
  min-width: 368px;
}

</style>

<script>
import { formatDate } from "@/ai_studio/utils/dataformatter";
import { Post } from "@/ai_studio/http/http";
export default {
  data() {
    return {
      custom_fields: this.$route.meta.custom_fields,
      selectedItem: null,
      post_result: null,
      snackbar: false,
      snackbar_options: {
        text: null,
        color: null,
        timeout: null,
      },
    };
  },
  props: {
    autocomplete_activated: {
      default: false,
    },
    actionActive: null,
    items: {
      type: Array,
    },

    cardWidth: {
      type: String,
      default: null,
    },

    cardHeight: {
      type: String,
      default: "auto",
    },
    md: {
      type: String,
      default: "6",
    },
    lg: {
      type: String,
      default: "4",
    },
    xlg: {
      type: String,
      default: "3",
    },

    actionType: {
      type: String,
      default: 'menu'
    },
    showAccessAction: {
      type: Boolean,
      default: false
    },
    showToggleAction: {
      type: Boolean,
      default: false
    },
    redirectLinkProp: {
      type: String,
      default: 'route'
    },

    titlecolor: String,
    titlefontfamily: String,
    titlefontsize: String,
    titlefontstyle: String,
    titlefontweight: String,
    titlelineheight: String,

    typecolor: String,
    typefontfamily: String,
    typefontsize: String,
    typefontstyle: String,
    typefontweight: String,
    typelineheight: String,

    desccolor: String,
    descfontfamily: String,
    descfontsize: String,
    descfontstyle: String,
    descfontweight: String,
    desclineheight: String,

    backgroudColor: String,
    isHome: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    CardStyle() {
      return {
        border: "1px solid #d4d4d4",
        width: "100%",
        minHeight: this.cardHeight,
        background: this.backgroudColor,
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
        boxSizing: "border-box",
      };
    },
    TitleStyle() {
      return {
        color: this.titlecolor,
        "font-family": this.titlefontfamily,
        "font-size": this.titlefontsize,
        "font-style": this.titlefontstyle,
        "font-weight": this.titlefontweight,
        "line-height": this.titlelineheight,
      };
    },
    TypeStyle() {
      return {
        display: "flex",
        color: this.typecolor,
        "margin-top": "4px",
        "justify-content": "flex-start",
        "font-family": this.typefontfamily,
        "font-size": this.typefontsize,
        "font-style": this.typefontstyle,
        "font-weight": this.typefontweight,
        "line-height": this.typelineheight,
      };
    },

    DescStyle() {
      return {
        display: "flex",
        color: this.desccolor,
        "font-family": this.descfontfamily,
        "font-size": this.descfontsize,
        "font-style": this.descfontstyle,
        "font-weight": this.descfontweight,
        "line-height": this.desclineheight,
      };
    },
  },
  mounted() {
    formatDate();
  },
  emits: ['access', 'toggle', 'action'],
  methods: {
    formatDate,
    passEvent(item) {
      this.$emit("action", item);
    },
    async disableSelectedItem(selectedValue, column_id) {
      let related_json = {
        column_id: column_id,
        column_field: selectedValue,
      };
      related_json = JSON.stringify(related_json);

      this.post_result = await Post(related_json, "saverelatedfields");

      if (this.post_result.success) {
        let old_relation = this.post_result.data.old_relation;
        let founds = 0;
        this.custom_fields.map((field) => {
          if (field.coluna === selectedValue) {
            field.disabled = true;
            founds++;
          } else if (field.coluna === old_relation) {
            field.disabled = false;
            founds++;
          }
          if (founds == 2) {
            return;
          }
        });

        this.snackbar = true;
        this.snackbar_options.text = "Vínculo realizado com sucesso";
        this.snackbar_options.color = "green";
        this.snackbar_options.timeout = 1500;
      } else {
        this.snackbar = true;
        this.snackbar_options.text = "Coluna vinculada a outro campo.";
        this.snackbar_options.color = "red";
        this.snackbar_options.timeout = -1;
      }
    },
    onAccess(item) {
      this.$emit('access', item);
    },
    onToggle(item) {
      this.$emit('toggle', item);
    },
    onRedirect(item) {
      const route = item[this.redirectLinkProp];
      if (route) {
        this.$router.push(route);
      }
    }
  },
};
</script>